import { Checkbox, Option, Select, Typography } from '@mui/joy';
import { useEffect, useState } from 'react';
import axios from '../../../config/axios.config';
import { AppModal } from '@app/components/AppModal';
import { RequestField } from '../components/RequestField';

type props = {
    onSuccess: () => void;
    open: boolean;
    onClose: () => void;
    idToUpdate: number[];
};

export const AssignReconductions = ({
    onSuccess,
    open,
    onClose,
    idToUpdate,
}: props) => {
    const [users, setUsers] = useState<any[]>([]);
    const [selectedUsersId, setSelectedUsersId] = useState<number>();
    const [selectedMandatId, setSelectedMandatId] = useState<number | string>();
    const [isAcvf, setIsAcvf] = useState<boolean>(false);

    useEffect(() => {
        axios
            .get('/user-login/collaborateur')
            .then((resp) => setUsers(resp.data.result));
    }, []);

    useEffect(() => {
        if (!open) {
            setIsAcvf(false);
            setSelectedMandatId(undefined);
        }
    }, [open]);

    const submit = () => {
        const promises = idToUpdate.map((id) =>
            axios.post(`/parrainages-reconductions/${id}/assign`, {
                collaborateurId: selectedUsersId,
                mandatId: isAcvf ? undefined : (selectedMandatId && selectedMandatId !== '' ? Number(selectedMandatId) : undefined),
            })
        );

        Promise.all(promises)
            .then(() => {
                onSuccess();
                onClose();
            })
            .catch((error) => {
                console.error('Erreur lors de l\'assignation:', error);
            });
    };

    return (
        <AppModal
            handleSubmit={submit}
            disabelSubmit={!selectedUsersId}
            icon="PencilSquareIcon"
            title="Assigner à un collaborateur"
            submitText="Assigner"
            submitIcon="PencilSquareIcon"
            open={open}
            onClose={onClose}
        >
            <div className="flex flex-col gap-2">
                <Typography fontSize="sm">Collaborateur</Typography>
                <Select
                    value={selectedUsersId}
                    onChange={(_, value) =>
                        setSelectedUsersId(value as number)
                    }
                >
                    {users.map((user) => (
                        <Option key={user.id} value={user.id}>
                            {user.userName}
                        </Option>
                    ))}
                </Select>
                <Checkbox
                    checked={isAcvf}
                    onChange={(event) => setIsAcvf(event.target.checked)}
                    label="ACVF"
                />
                <Typography fontSize="sm">Nouveau numéro de mandat (Club ID)</Typography>
                <RequestField
                    apiUrl="/mandats"
                    keyRelation="ref"
                    keyResult="id"
                    type="autocomplete"
                    onChange={(value) => setSelectedMandatId(value)}
                    value={selectedMandatId || ''}
                    disabled={isAcvf}
                />
            </div>
        </AppModal>
    );
};
export default AssignReconductions;

